import React, { useRef, useEffect } from "react";

// ICONS OPEN
import {
  Work,
  Delete,
  AccessTime,
  AddCard,
  Comment,
  CancelPresentation,
  CheckBox,
} from "@mui/icons-material";

import {
  Button,
  Box,
  Tabs,
  Tab,
  Card,
  CardContent,
  CardActions,
  Alert,
} from "@mui/material/";
import { CustomButtonPlusIcon } from "../../../Components/Common/Design/CustomButtonPlusIcon";
import { alpha, lighten } from "@mui/material/styles";
import Mailbox from "../../../Mensajes/Mailbox";

const MessagesTab = ({
  addDataTab,
  editDataTab,
  setAddDataTab,
  setEditDataTab,
  Editor,
  editorState,
  onEditorChange,
  dataCaseNotesAlertsMessages,
  selectionStyleMessage,
  setSelectionStyleMessage,
  handleDeleteDataTabs,
  handleCancelDataTabs,
  handleSubmitDataTabs,
  dataCase,
}) => {
  return (
    <Box sx={{ display: "flex", gap: 3, width: "100%" }}>
      <Mailbox dataCase={dataCase} heighProp={"800px"} insideCase={true} />
    </Box>
  );
};

export default MessagesTab;
